import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import "../assets/css/uk-ads-home.css";
import logo from "../assets/images/uk-ads/logo.png";
import heroBanner from "../assets/images/uk-ads/hero-banner.png";
import diamondGrid from "../assets/images/uk-ads/diamond-grid.png";
import phoneIcon from "../assets/images/uk-ads/phone.svg";
import mailIcon from "../assets/images/uk-ads/mail.svg";
import mapIcon from "../assets/images/uk-ads/map.svg";
import whatsappIcon from "../assets/images/whatsapp-sm.svg";
import jaipurTourImage from "../assets/images/Golden-Traingle-shortTour-India.jpg";
import tigerTourImage from "../assets/images/goldentrianglestandardtour.jpg";
import royalrajasthan from "../assets/images/aboutus_tour.webp";
import triangletigerTourImage from "../assets/images/Golden-Triangle-Tiger-Tour.jpg";
import bestIndiaTourImage from "../assets/images/oberoihotel.jpg";
import theimperail from "../assets/images/theimperial.avif";
import rambagpalace from "../assets/images/rambagpalace.avif";
import oberoihotel from "../assets/images/oberoihotels.avif";
import reviewbigimg from "../assets/images/big.png";
import img1 from "../assets/images/1.png";
import img2 from "../assets/images/2.png";
import img5 from "../assets/images/5.png";
import img4 from "../assets/images/4.png";
import YouTubeVideo from "../components/YouTubeVideo";

const arrowIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12" fill="none" aria-hidden="true">
    <path d="M0.833374 5.83333H14.1667M9.16671 10.8333L14.1667 5.83333L9.16671 0.833332" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);


const tourCards = [
  {
    tag: "Delhi - Agra - Jaipur / 4N - 3D",
    title: "Golden Triangle - Short Tour",
    desc: "",
    href: "/golden-triangle-short-tour/",
    alt: "Golden Triangle - Short Tour",
    image: jaipurTourImage,
  },
  {
    tag: "Delhi - Agra - Jaipur / 6N - 7D",
    title: "Golden Triangle - Standard Tour",
    desc: "",
    href: "/golden-triangle-standard-tour",
    alt: "Golden Triangle - Standard Tour",
    image: tigerTourImage,
  },
  {
    tag: "Golden Triangle - Oberoi Hotels / 6N - 7D",
    title: "Golden Triangle - Oberoi Hotels",
    desc: "",
    href: "/golden-triangle-oberoi-hotels",
    alt: "Golden Triangle - Oberoi Hotels",
    image: bestIndiaTourImage,
  },
  {
    tag: "+ Ranthambhore - Jaipur 8N - 9D",
    title: "Golden Triangle & Tiger Tour",
    desc: "",
    href: "/golden-triangle-tiger-tour/",
    alt: "Golden Triangle & Tiger Tour",
    image: triangletigerTourImage,
  },
  {
    tag: "+ Rawla Narlai - Udaipur / 9-14 Nights / 10-15 Days",
    title: "Best of India Tour",
    desc: "",
    href: "/best-luxury-private-india-tour",
    alt: "Best of India Tour",
    image: royalrajasthan,
  },
];

const reviewCards = [
  {
    src: "https://www.youtube.com/embed/oK4OnNv0wK0",
    title: "Luxury Golden Triangle Tour | UK Guest Review / Feedback",
  },
  {
    src: "https://www.youtube.com/embed/5aWIB589zOo",
    title: "Luxury Golden Triangle Tour | #Switzerland (#Swiss) guest feedback/Testimonial",
  },
  {
    src: "https://www.youtube.com/embed/1r9rRk2xpSI",
    title: "A family from USA on a Luxury Tour of India.",
  },
  {
    src: "https://www.youtube.com/embed/Nqgfn-tdxpo",
    title: "Luxury Golden Triangle Tour | United Kingdom #UK Guest Feedback",
  },
  {
    src: "https://www.youtube.com/embed/ocvwsnkA39I",
    title: "Luxury Golden Triangle Tour | Bulgaria Guest Review/Feedback",
  },
  {
    src: "https://www.youtube.com/embed/P0LT3RPppuw",
    title: "Luxury Golden Triangle Tour | #Mexico Guest Review/Feedback",
  },
  {
    src: "https://www.youtube.com/embed/h7Wj1cMSEjk",
    title: "Luxury Golden Triangle Tour | USA Guest Review",
  },
  
];

const initialForm = {
  name: "",
  email: "",
  phone: "",
  message: "",
};

function UkAdsHome() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [reviewCenterIndex, setReviewCenterIndex] = useState(2);
  const tourCarouselRef = useRef(null);
  const reviewCarouselRef = useRef(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
    if (errors[name]) {
      setErrors((current) => ({ ...current, [name]: "" }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus({ type: "", message: "" });
    setErrors({});

    const name = formData.name.trim();
    const email = formData.email.trim();
    const phone = formData.phone.trim();
    const message = formData.message.trim();
    const nextErrors = {};

    if (!name) {
      nextErrors.name = "Name is required.";
    }
    if (!email) {
      nextErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      nextErrors.email = "Enter a valid email address.";
    }
    if (!phone) {
      nextErrors.phone = "Phone number is required.";
    }
    if (!message) {
      nextErrors.message = "Message is required.";
    }
    if (!captchaToken) {
      nextErrors.captcha = "Please verify captcha.";
    }

    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      setStatus({ type: "error", message: "Please correct the highlighted fields." });
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch("https://www.luxurygoldentriangle.com/bkadmn/wp-json/custom/v1/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          email,
          phone,
          message,
          form_type: "uk_ads_contact",
          page_url: "https://www.luxurygoldentriangle.com/tailor-made-private-tour/",
          captcha: captchaToken,
        }),
      });

      const result = await response.json().catch(() => ({}));
      if (!response.ok || result.success === false) {
        throw new Error(result.message || "Email could not be sent. Please try again.");
      }

      setFormData(initialForm);
      setCaptchaToken(null);
      setStatus({ type: "success", message: "Message sent successfully!" });
    } catch (error) {
      setStatus({ type: "error", message: error.message || "Server error. Please try again." });
    } finally {
      setIsSubmitting(false);
    }
  };

  const closeMenu = () => setIsMenuOpen(false);
  const moveCarousel = (carouselRef, direction) => {
    const carousel = carouselRef.current;
    if (!carousel) {
      return;
    }

    const firstSlide = carousel.querySelector(".owl-item");
    const slideWidth = firstSlide ? firstSlide.getBoundingClientRect().width : carousel.clientWidth;
    carousel.scrollBy({ left: direction * slideWidth, behavior: "smooth" });
  };

  const moveTourCarousel = (direction) => moveCarousel(tourCarouselRef, direction);

  const moveReviewCarousel = (direction) => {
    setReviewCenterIndex((current) => {
      const nextIndex = (current + direction + reviewCards.length) % reviewCards.length;
      return nextIndex;
    });
    moveCarousel(reviewCarouselRef, direction);
  };

  return (
    <main className="uk-ads-page">
      <header className="header">
  <div className="container header-inner">
   
	<Link target="_blank" to="/tailor-made-private-tour/" className="logo" onClick={closeMenu}>
            <img src={logo} alt="Luxury Golden Triangle" />
          </Link>
    <nav className={`nav-links ${isMenuOpen ? "open" : ""}`} id="navLinks">
      <Link target="_blank" to="/" onClick={closeMenu}>Home</Link>
      <Link target="_blank" to="/about-us" onClick={closeMenu}>About Us</Link>
      <Link target="_blank" to="/tours" onClick={closeMenu}>Tours</Link>
      <Link target="_blank" to="/luxury-golden-triangle-enquiry" onClick={closeMenu}>Tailor Made Tours</Link>
      <Link target="_blank" to="/video-reviews" onClick={closeMenu}>Video Reviews</Link>
      <Link target="_blank" to="#contact" onClick={closeMenu}>Contact</Link>
    </nav>
    <Link target="_blank" to="/contact" className="btn btn-white">
      Enquire{" "}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={12}
        viewBox="0 0 15 12"
        fill="none"
      >
        <path
          d="M0.833374 5.83333H14.1667M9.16671 10.8333L14.1667 5.83333L9.16671 0.833332"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Link>
    <button
      className="nav-toggle"
      id="navToggle"
      aria-label="Toggle navigation"
      type="button"
      onClick={() => setIsMenuOpen((open) => !open)}
    >
      <span />
      <span />
      <span />
    </button>
  </div>
</header>


      <section className="hero">
  <div className="container hero-inner">
    <div className="hero-text">
      <h1>
        You're not our <span className="accent">Traveler</span>.<br />
        You're our <span className="accent">Guest</span>
      </h1>
      <p>
        Bespoke, private journeys through India, designed around you, welcomed
        like family.
      </p>
      <Link  to="#contact" className="btn1 btn-gold1">
        Design My Luxury Tour{" "}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={15}
          height={12}
          viewBox="0 0 15 12"
          fill="none"
        >
          <path
            d="M0.833374 5.83333H14.1667M9.16671 10.8333L14.1667 5.83333L9.16671 0.833332"
            stroke="white"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Link>
    </div>
    <div className="hero-image">
      <img
        src={heroBanner}
        alt="Couple at a heritage palace in India"
      />
      <div className="hero-badge">
        <span className="icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={10}
            height={10}
            viewBox="0 0 10 10"
            fill="none"
          >
            <circle cx={5} cy={5} r={5} fill="#F82D2D" />
          </svg>
        </span>
        <span>
          Certified Tour Operator, Ministry of Tourism, Govt. of India
        </span>
      </div>
    </div>
  </div>
  <div className="trust-bar">
    <div className="container">
      <ul className="trust-list">
        <li>✓ Handpicked Five-Star Hotels &amp; Heritage Palaces</li>
        <li>✓ Private Chauffeur-Driven Luxury Fleet</li>
        <li>✓ Bespoke, Tailor-Made Itineraries</li>
        <li> ✓ Government-Licensed Tour Operator</li>
        <li>✓ Your Own Dedicated Travel Concierge</li>
        <li>✓ Transparent Pricing, No Hidden Extras</li>
      </ul>
    </div>
  </div>
</section>



     <section className="philosophy" id="about">
  <div className="container philosophy-inner">
    <div className="diamond-grid">
      <img src={diamondGrid} alt="diamond-grid" />
    </div>
    <div className="philosophy-text">
      <p className="eyebrow">Our Philosophy</p>
      <h2 className="section-title">What Luxury Means to Us</h2>
      <p>
        Luxury, to us, is not simply a five-star hotel or an elegant car. It is
        the quiet reassurance that every detail of your journey has been
        considered before you even think to ask.
      </p>
      <p>
        From your private chauffeur and personal guide to the hotels we select
        and the moments we curate along the way, everything is arranged so that
        you need only do one thing: enjoy the journey.
      </p>
      <p className="philosophy-quote">
        "We take care of the logistics. You take in India."
      </p>
      <Link to="#tours" className="btn1 btn-outline1">
        Discover the Luxury Difference{" "}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={15}
          height={12}
          viewBox="0 0 15 12"
          fill="none"
        >
          <path
            d="M0.833313 5.83337H14.1666M9.16665 10.8334L14.1666 5.83337L9.16665 0.833374"
            stroke="#A2750F"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>	
      </Link>
    </div>
  </div>
</section>

<section className="tours" id="tours">
  <div className="container">
    <div className="tours-head">
      <p className="eyebrow">Curated Journeys</p>
      <h2 className="section-title blck">
        Explore Our Luxury Golden Triangle Tours
      </h2>
      <p className="section-sub blck">
        A carefully curated collection of journeys through Delhi, Agra and
        Jaipur, each one designed to reveal India's timeless heritage with
        world-class comfort and the personal attention of a private tour.
      </p>
    </div>
    <div
      className="owl-carousel owl-theme uk-ads-tour-carousel"
      id="toursCarousel"
    >
      <div className="owl-stage-outer" ref={tourCarouselRef}>
        <div className="owl-stage">
          {tourCards.map((tour) => (
            <div className="owl-item" key={`${tour.title}-${tour.tag}`}>
              <div className="tour-card">
                <div className="tour-card-img">
                  <img src={tour.image} alt={tour.alt} />
                </div>
                <div className="tour-card-body">
                  <span className="tour-card-tag">{tour.tag}</span>
                  <h3 className="tour-card-title">{tour.title}</h3>
                  <p className="tour-card-desc">{tour.desc}</p>
                  <Link target="_blank" to={tour.href} className="tour-card-link">View Itinerary</Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="owl-nav">
        <button type="button" role="presentation" className="owl-prev" onClick={() => moveTourCarousel(-1)} aria-label="Previous tour">❮</button>
        <button type="button" role="presentation" className="owl-next" onClick={() => moveTourCarousel(1)} aria-label="Next tour">❯</button>
      </div>
      <div className="owl-dots disabled"></div>
    </div>
  </div>
</section>


<section className="bespoke" id="bespoke">
  <div className="container bespoke-inner">
    <div className="bespoke-text">
      <h3>Need Something Personal and Bespoke?</h3>
      <p>
        No two travellers want the same holiday. Perhaps you'd like to extend
        your stay, add a destination, choose a particular hotel, or arrange a
        private experience unavailable to the wider public. Our travel
        specialists will build an itinerary around your preferences, not the
        other way round.
      </p>
      <p style={{ marginTop: 14 }}>
        Tell us what you have in mind, and we'll design a journey that belongs
        entirely to you.
      </p>
    </div>
    <Link to="#contact" className="btn1 btn-gold1">
      Request a Bespoke Itinerary{" "}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={12}
        viewBox="0 0 15 12"
        fill="none"
      >
        <path
          d="M0.833374 5.83333H14.1667M9.16671 10.8333L14.1667 5.83333L9.16671 0.833332"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Link>
  </div>
</section>
<section className="features">
    <div className="container">
      <h2>Features</h2>
      <p className="sub">Make your trip a memorable one!</p>

      <div className="features-grid">
        <div className="feature-item">
          <div className="icon">✂</div>
          <h4>Customized Itineraries</h4>
          <p>Customize your tour based on tour duration, preferred hotel or type of car.</p>
        </div>
        <div className="feature-item">
          <div className="icon">🏨</div>
          <h4>Luxury 5 Star &amp; Heritage Hotels</h4>
          <p>Choose from a wide range of luxury and heritage hotels.</p>
        </div>
        <div className="feature-item">
          <div className="icon">🚘</div>
          <h4>Highly Experienced Drivers</h4>
          <p>Our drivers are highly experienced and professional. They can go extra miles for your comfort.</p>
        </div>
        <div className="feature-item">
          <div className="icon">🎙</div>
          <h4>Professional Guides</h4>
          <p>Knowledgeable &amp; experienced guides to show you the best of the city.</p>
        </div>
        <div className="feature-item">
          <div className="icon">🎎</div>
          <h4>Authentic Experiences</h4>
          <p>Traditional Himalayan Wedding, Diwali with Family or Shopping a Saree. You just Name it!</p>
        </div>
        <div className="feature-item">
          <div className="icon">🛎</div>
          <h4>Luxury Amenities During Your Tour</h4>
          <p>Mineral Water Bottle, Free Wifi, Umbrella etc. for a smooth and luxury ride.</p>
        </div>
        <div className="feature-item">
          <div className="icon">🎧</div>
          <h4>Dedicated Travel Expert</h4>
          <p>Dedicated travel expert from the planning phase till your departure for a smooth experience.</p>
        </div>
        <div className="feature-item">
          <div className="icon">⏰</div>
          <h4>24 X 7 Personal Assistance</h4>
          <p>Round the clock customer care for any assistance during your tour.</p>
        </div>
      </div>
    </div>
  </section>
  
  <section className="reviews">
  <div className="container">
    <div className="reviews-head">
      <p className="eyebrow">Hear From Our Luxury Travelers</p>
      <h2 className="section-title">Video Reviews From The Road</h2>
      <p className="section-sub" style={{ margin: "0 auto" }}>
        Real journeys, told by the families and couples who took them - pulled
        from our guests' own recap videos.
      </p>
    </div>
    <div
      className="owl-carousel owl-theme owl-loaded owl-drag uk-ads-review-carousel"
      id="reviewsCarousel"
    >
      <div className="owl-stage-outer" ref={reviewCarouselRef}>
        <div className="owl-stage">
          
		  {reviewCards.map((review, index) => (
  <div
    className={`owl-item ${
      index === reviewCenterIndex ? "center" : ""
    }`}
    key={review.src + index}
  >
    <div className="review-item">
      <div className="review-card">
        <YouTubeVideo
          width="100%"
          height="340px"
          src={review.src}
          title={review.title}
          frameBorder={0}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
    </div>
  </div>
))}


        </div>
      </div>
      <div className="owl-nav">
        <button type="button" role="presentation" className="owl-prev" onClick={() => moveReviewCarousel(-1)} aria-label="Previous review">❮</button>
        <button type="button" role="presentation" className="owl-next" onClick={() => moveReviewCarousel(1)} aria-label="Next review">❯</button>
      </div>
      <div className="owl-dots disabled"></div>
    </div>
    <Link target="_blank" to="/video-reviews/" className="btn1 btn-outline" style={{ marginTop: 40 }}>
      Watch All Video Reviews →
    </Link>
  </div>
</section>


  <section className="hotels">
  <div className="container">
    <div className="hotels-head">
      <p className="eyebrow">Where You Rest</p>
      <h2 className="section-title">Stay at India's Finest Hotels</h2>
      <p>
        We work exclusively with a select group of five-star hotels, heritage
        palaces and internationally renowned resorts - chosen not just for
        comfort, but for the sense of place and history they offer.
      </p>
    </div>
    <div className="hotels-grid">
      <div className="hotel-card">
        <div className="hotel-card-inner">
          <img
            src={oberoihotel}
            alt="Oberoi Hotel, Agra"
          />
          <div className="hotel-label">
            <span className="place">AGRA</span>
            <span className="name">Oberoi Hotel</span>
          </div>
        </div>
      </div>
      <div className="hotel-card offset">
        <img
          src={rambagpalace} alt="Rambagh Palace, Jaipur"
        />
        <div className="hotel-label">
          <span className="place">JAIPUR</span>
          <span className="name">Rambagh Palace</span>
        </div>
      </div>
      <div className="hotel-card">
        <img
          src={theimperail}
          alt="The Imperial, Delhi"
        />
        <div className="hotel-label">
          <span className="place">DELHI</span>
          <span className="name">The Imperial</span>
        </div>
      </div>
    </div>
    <div className="hotels-cta">
      <Link target="_blank" to="/5-star-luxury-hotels/" className="btn1 btn-gold1">
        Explore Our 5 Star Hotel Collection{" "}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={15}
          height={12}
          viewBox="0 0 15 12"
          fill="none"
        >
          <path
            d="M0.833374 5.83333H14.1667M9.16671 10.8333L14.1667 5.83333L9.16671 0.833332"
            stroke="white"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Link>
    </div>
  </div>
</section>

     <section className="gallery">
  <div className="container">
    <div className="gallery-head">
      <p className="eyebrow">Our Gallery</p>
      <h2 className="section-title">View Our Luxury Gallery</h2>
    </div>
    <div className="gallery-grid">
      <div className="gallery-item big">
        <img
          src={reviewbigimg}
          alt="Luxury hotel pool"
        />
      </div>
      <div className="gallery-item">
        <img
          src={img1}
          alt="Palace architecture"
        />
      </div>
      <div className="gallery-item">
        <img
          src={img2}
          alt="Leela Palace New Delhi"
        />
      </div>
      <div className="gallery-item">
        <img
          src={img5}
          alt="Leela Palace Jaipur"
        />
      </div>
      <div className="gallery-item">
        <img
          src={img4}
          alt="Palace at dusk"
        />
      </div>
    </div>

  </div>
</section>

<section className="contact" id="contact">
  <div className="container contact-inner">
    <div className="contact-info1">
      <p className="eyebrow">Get In Touch</p>
      <h2>Let's Design Your Journey Through India</h2>
      <p>
        Our team responds within 24 hours. For guests already travelling with
        us, we're reachable around the clock.
      </p>
      <div className="contact-detail">
        <span className="icon">
          <img src={phoneIcon} alt="" />
        </span>
        <div>
          <strong>Call Us</strong>+91 94165 75716
        </div>
      </div>
      <div className="contact-detail">
        <span className="icon">
          <img src={mailIcon} alt="" />
        </span>
        <div>
          <strong>Email</strong>contact@luxurygoldentriangle.com
        </div>
      </div>
      <div className="contact-detail">
        <span className="icon">
          <img src={mapIcon} alt="" />
        </span>
        <div>
          <strong>Our Office</strong>Pitampura, New Delhi, India 110034
        </div>
      </div>
    </div>

    <form className="contact-form" onSubmit={handleSubmit} noValidate>
      <div className="form-row">
        <div className="form-group full">
          <label htmlFor="fullName">Full Name</label>
          <input type="text" id="fullName" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange}/>
          {errors.name && <p className="error">{errors.name}</p>}
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="email" placeholder="you@email.com" value={formData.email} onChange={handleChange} />
          {errors.email && <p className="error">{errors.email}</p>}
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <input type="tel" id="phone" name="phone" placeholder="+1000000000" value={formData.phone} onChange={handleChange} />
          {errors.phone && <p className="error">{errors.phone}</p>}
        </div>
      </div>
      <div className="form-row">
        <div className="form-group full">
          <label htmlFor="message">Tell us about your journey</label>
          <textarea
            id="message"
            name="message"
            placeholder="Travel dates, group size, interests..."
             value={formData.message} onChange={handleChange}
          />
          {errors.message && <p className="error">{errors.message}</p>}
        </div>
      </div>
      <div className="uk-ads-captcha">
        <ReCAPTCHA
          sitekey="6Ld4kHosAAAAAKsayfQ1saymv6SeauUSxkHSn55b"
          onChange={(token) => {
            setCaptchaToken(token);
            setErrors((current) => ({ ...current, captcha: "" }));
          }}
          onExpired={() => {
            setCaptchaToken(null);
            setErrors((current) => ({ ...current, captcha: "Please verify captcha." }));
          }}
        />
        {errors.captcha && <p className="error">{errors.captcha}</p>}
      </div>
      {status.message && <p className={status.type === "success" ? "success" : "error"}>{status.message}</p>}
      <button type="submit" className="btn1 btn-gold1 mt-10"
        disabled={isSubmitting}>{isSubmitting ? "Sending..." : "Send Enquiry"} {arrowIcon}
      </button>
    </form>
  </div>
</section>
<footer className="footer">
  <div className="container">
    <div className="footer-inner">
      <div className="footer-logo">
        <Link target="_blank" to="/" className="logo">
          <img src={logo} alt="Luxury Golden Triangle" />
        </Link>
        <p>
          India captivates with its rich culture, ancient heritage and
          extraordinary diversity. At the heart of it all lies our Luxury Golden
          Triangle Tour - a bespoke private journey through Delhi, Agra and
          Jaipur, travelling by private car and staying in heritage palaces and
          handpicked luxury hotels, with curated extensions into Rajasthan,
          Varanasi and the wellness retreats of Kerala.
        </p>
      </div>
      <div className="footer-col">
        <h5>Explore</h5>
        <ul>
          <li>
            <Link target="_blank" to="/5-star-luxury-hotels/">5* Hotels List</Link>
          </li>
          <li>
            <Link target="_blank" to="/car-details/">Car Details</Link>
          </li>
          <li>
            <Link target="_blank" to="/luxury-golden-triangle-enquiry/">Customize Your Tour</Link>
          </li>
          <li>
            <Link target="_blank" to="/terms-conditions/">Term &amp; Conditions</Link>
          </li>
          <li>
            <Link target="_blank" to="/faq/">FAQ</Link>
          </li>
        </ul>
      </div>
      <div className="footer-col">
        <h5>Contact</h5>
        <ul>
          <li>
            #296, Ground Floor, Christown, Pitampura, New Delhi, India 110034
          </li>
          <li>Mon - Sat: 9AM - 6PM</li>
        </ul>
      </div>
    </div>
    {/* <div class="footer-bottom">
  © 2026 Luxury Golden Triangle. All Rights Reserved.
</div> */}
  </div>
</footer>

      <div className="uk-ads-whatsapp-float">
        <Link
          to="https://wa.me/919416575716"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
        >
          <img src={whatsappIcon} alt="WhatsApp" />
        </Link>
      </div>

    </main>
  );
}

export default UkAdsHome;
